import axios from "axios";

const DEFAULT_TIMEOUT_MS = 10000;

export async function fetchWhitelabelByChannel(timeoutMs = DEFAULT_TIMEOUT_MS) {
  const API_URL_CONFIG = process.env.REACT_APP_CONFIGS_API;
  const API_TOKEN_CONFIG = process.env.REACT_APP_CONFIGS_API_TOKEN;
  const API_CHANNEL = process.env.REACT_APP_CONFIGS_CHANNEL;

  if (!API_URL_CONFIG || !API_TOKEN_CONFIG || !API_CHANNEL) {
    throw new Error("Variáveis REACT_APP_CONFIGS_* incompletas para whitelabel");
  }

  const whitelabelUrl = `${API_URL_CONFIG}/whitelabels/byChannel/${API_CHANNEL}`;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await axios.get(whitelabelUrl, {
      headers: { Authorization: `Bearer ${API_TOKEN_CONFIG}` },
      signal: controller.signal,
      timeout: timeoutMs,
    });
    clearTimeout(timeoutId);
    if (response?.data?.data) {
      return response.data.data;
    }
    throw new Error("Nenhum dado de whitelabel retornado na resposta");
  } catch (error) {
    clearTimeout(timeoutId);
    throw error;
  }
}
